// src/components/ui/popover.tsx
"use client"

import React from "react"
import type { ElementRef, ComponentPropsWithoutRef } from "react"
import {
  Root as PopoverRoot,
  Trigger as PopoverTriggerPrimitive,
  Portal as PopoverPortal,
  Content as PopoverContentPrimitive,
} from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

const Popover = PopoverRoot
const PopoverTrigger = PopoverTriggerPrimitive

const PopoverContent = React.forwardRef<
  ElementRef<typeof PopoverContentPrimitive>,
  ComponentPropsWithoutRef<typeof PopoverContentPrimitive>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPortal>
    <PopoverContentPrimitive
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        "origin-[--radix-popover-content-transform-origin]",
        className
      )}
      {...props}
    />
  </PopoverPortal>
))
PopoverContent.displayName = "PopoverContent"

export { Popover, PopoverTrigger, PopoverContent }